import { getDefaultData } from './get-default-data';
import { navigation } from '@exploration/cms-constants';
import { svgIcons } from '@exploration/icons';

const cmsData = getDefaultData();

const column1Links = [
  cmsData.callToAction?.[navigation.footer_links.footer_column_1_link_1],
  cmsData.callToAction?.[navigation.footer_links.footer_column_1_link_2],
  cmsData.callToAction?.[navigation.footer_links.footer_column_1_link_3],
  cmsData.callToAction?.[navigation.footer_links.footer_column_1_link_4],
].map((link) => ({
  label: link.text,
  altText: link.text,
  url: link.href,
}));

const column2Links = [
  cmsData.callToAction?.[navigation.footer_links.footer_column_2_link_1],
  cmsData.callToAction?.[navigation.footer_links.footer_column_2_link_2],
  cmsData.callToAction?.[navigation.footer_links.footer_column_2_link_3],
  cmsData.callToAction?.[navigation.footer_links.footer_column_2_link_4],
].map((link) => ({
  label: link.text,
  altText: link.text,
  url: link.href,
}));

const column3Links = [
  cmsData.callToAction?.[navigation.footer_links.footer_column_3_link_1],
  cmsData.callToAction?.[navigation.footer_links.footer_column_3_link_2],
  cmsData.callToAction?.[navigation.footer_links.footer_column_3_link_3],
  cmsData.callToAction?.[navigation.footer_links.footer_column_3_link_4],
  cmsData.callToAction?.[navigation.footer_links.footer_column_3_link_5],
].map((link) => ({
  label: link.text,
  altText: link.text,
  url: link.href,
}));

const column4Links = [
  cmsData.callToAction?.[navigation.footer_links.footer_column_4_link_1],
  cmsData.callToAction?.[navigation.footer_links.footer_column_4_link_2],
  cmsData.callToAction?.[navigation.footer_links.footer_column_4_link_3],
  cmsData.callToAction?.[navigation.footer_links.footer_column_4_link_4],
].map((link) => ({
  label: link.text,
  altText: link.text,
  url: link.href,
}));

const resourceLinks = [
  cmsData.callToAction?.[navigation.footer_links.footer_resource_link_1],
  cmsData.callToAction?.[navigation.footer_links.footer_resource_link_2],
  cmsData.callToAction?.[navigation.footer_links.footer_resource_link_3],
  cmsData.callToAction?.[navigation.footer_links.footer_resource_link_4],
  cmsData.callToAction?.[navigation.footer_links.footer_resource_link_5],
].map((link) => ({
  label: link.text,
  altText: link.text,
  url: link.href,
}));

const socialLinks = [
  cmsData.callToAction?.[navigation.footer_links.footer_social_link_1],
  cmsData.callToAction?.[navigation.footer_links.footer_social_link_2],
  cmsData.callToAction?.[navigation.footer_links.footer_social_link_3],
  cmsData.callToAction?.[navigation.footer_links.footer_social_link_4],
  cmsData.callToAction?.[navigation.footer_links.footer_social_link_5],
].map((link) => ({
  label: link.text,
  altText: link.text,
  url: link.href,
}));

const footerText = {
  title: cmsData?.text?.[navigation.footer_links.footer_top_title],
  column1Title: cmsData?.text?.[navigation.footer_links.footer_column_1_title],
  column2Title: cmsData?.text?.[navigation.footer_links.footer_column_2_title],
  column3Title: cmsData?.text?.[navigation.footer_links.footer_column_3_title],
  column4Title: cmsData?.text?.[navigation.footer_links.footer_column_4_title],
  brokerCheckSVG: svgIcons.brokerCheck,
  brokerCheckText: cmsData?.text?.[navigation.footer_links.brokerCheckText],
};

const disclosures = cmsData.list?.disclosures;

export const footerData = {
  footerText,
  column1Links,
  column2Links,
  column3Links,
  column4Links,
  resourceLinks,
  socialLinks,
  disclosures,
};
